import Home from './components/Home'
import Resume from './components/Resume'
import Projects from './components/Projects'
import Blog from './components/Blog'
import Publication from './components/Publications'

export const routes = [
    {path: '/', component: Home},
    {path: '/resume', component: Resume},
    {path: '/projects', component: Projects},
    {path: '/blogs', component: Blog},
    {path: '/publications', component: Publication},
    { path: '*', redirect: '/' },
];